import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a2c38d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "others-view-pc"
};
import { computed, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  __name: 'OthresViewPC',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      allowType: ['thread', 'thread-only-reply', 'draft', 'follow', 'follower', 'notice'],
      nnn: 0,
      tabs: {
        'rule': {
          val: 'rule',
          txt: '社区规则'
        },
        'privacy': {
          val: 'privacy',
          txt: '隐私说明'
        },
        'aboutus': {
          val: 'aboutus',
          txt: '关于我们'
        },
        'appdownload': {
          val: 'appdownload',
          txt: 'APP下载'
        }
      }
    });
    const tabs = computed(() => {
      return state.tabs;
    });
    const selectedTab = computed({
      get() {
        return route.name || '';
      },
      set(newVal) {
        router.push({
          path: '/others/' + newVal
        });
      }
    });
    onMounted(() => {
      window.scrollTo(0, 0);
      store.commit('forum/setSelectedForum', '');
    });
    router.beforeEach((to, from, next) => {
      window.scrollTo(0, 0);
      next();
    });
    return (_ctx, _cache) => {
      const _component_TabsPC = _resolveComponent("TabsPC");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_TabsPC, {
        data: _unref(tabs),
        selected: _unref(selectedTab),
        "onUpdate:selected": _cache[0] || (_cache[0] = $event => _isRef(selectedTab) ? selectedTab.value = $event : null)
      }, null, 8, ["data", "selected"]), _createVNode(_component_router_view)]);
    };
  }
};